import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import MetricSetup from 'webapp/models-custom/metric-setup';

import type MetricDetailsService from 'webapp/services/metric-details';

export default class MetricsDetailRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('metric-details')
	declare metricDetailsService: MetricDetailsService;

	override async beforeModel(transition: PublicTransition) {
		const { metricKey, ...newQueryParams } = { ...(transition.to?.queryParams || {}) };

		// The account app's Data Manager links a metric by its key (?metricKey=<spaceAccessId>|<key>)
		if (typeof metricKey === 'string') {
			await this.mmMetricsService.requestMetrics();
			const metricData = this.mmMetricsService.findRecord(metricKey)?.metricData;
			if (metricData) {
				this.navigationService.replaceRoute(
					this.metricDetailsService.buildShareablePathFromOptions({
						metricSetup: new MetricSetup(metricData),
					}),
				);
				return;
			}
		}

		if (newQueryParams.attribute) {
			newQueryParams.attributes = [newQueryParams.attribute];
			delete newQueryParams.attribute;
		}

		this.navigationService.replaceRoute('metrics.details', {
			queryParams: newQueryParams,
		});
	}
}
